import React from "react";
import styles from "./portal_image_card.module.css";

interface PortalImageCardProps {
  imgUrl: string;
  imgAlt: string;
  imgHeight: number;
  details: JSX.Element;
}

export function PortalImageCard({
  imgAlt,
  imgHeight,
  imgUrl,
  details,
}: PortalImageCardProps) {
  return (
    <div className={styles.component}>
      <div style={{ height: imgHeight }}>
        <img
          className={styles.img}
          src={imgUrl}
          alt={imgAlt}
          height={imgHeight}
        />
      </div>
      <div
        className={styles.detailsWrapper}
        style={{ height: `calc(100% - ${imgHeight}px)` }}
      >
        {details}
      </div>
    </div>
  );
}
